module.exports = __webpack_public_path__ + "img/calendar.8a8ea54a.svg";